import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        component: () => import('./views/Home.vue')
    },
    {
        path: '/plugin/',
        component: () => import('./layouts/Nav.vue'),
        children: [{
            path: 'plugin',
            component: () => import('./views/plugin/Plugin.vue')
        },
        {
            path: 'plugin-info',
            component: () => import('./views/plugin/Plugin-info.vue')
        }
        ]
    },
    {
        path: '/passport/',
        component: () => import('./layouts/Passport.vue'),
        children: [{
            path: 'register',
            component: () => import('./views/passport/Register.vue')
        },
        {
            path: 'login',
            component: () => import('./views/passport/Login.vue')
        },
        {
            path: 'reset-password',
            component: () => import('./views/passport/ResetPassword.vue')
        }
        ]
    },
    {
        path: '/dashboard/',
        component: () => import('./layouts/Dashboard.vue'),
        redirect: '/dashboard/user/index',
        children: [{
            path: 'user/index',
            component: () => import('./views/user/Index.vue')
        },
        {
            path: 'host/index',
            component: () => import('./views/host/Index.vue')
        },
        {
            path: 'host/edit',
            component: () => import('./views/host/Edit.vue')
        },
        {
            path: 'plugin-order/index',
            component: () => import('./views/plugin-order/Index.vue')
        },
        {
            path: 'plugin-order/edit',
            component: () => import('./views/plugin-order/Edit.vue')
        },
        {
            path: 'admin/',
            component: () => import('./layouts/Admin.vue'),
            children: [{
                path: 'user/index',
                component: () => import('./views/admin/user/Index.vue')
            },
            {
                path: 'user/add',
                component: () => import('./views/admin/user/add.vue')
            },
            {
                path: 'user/edit',
                component: () => import('./views/admin/user/Edit.vue')
            },
            {
                path: 'host/index',
                component: () => import('./views/admin/host/Index.vue')
            },
            {
                path: 'host/edit',
                component: () => import('./views/admin/host/Edit.vue')
            },
            {
                path: 'host/auth-warning',
                component: () => import('./views/admin/host/AuthWarning.vue')
            },
            {
                path: 'plugin-order/index',
                component: () => import('./views/admin/plugin-order/Index.vue')
            },
            {
                path: 'plugin/index',
                component: () => import('./views/admin/plugin/Index.vue')
            },
            {
                path: 'plugin/edit',
                component: () => import('./views/admin/plugin/Edit.vue')
            },
            {
                path: 'plugin/version',
                component: () => import('./views/admin/plugin/Version.vue')
            },
            {
                path: 'plugin/version-edit',
                component: () => import('./views/admin/plugin/VersionEdit.vue')
            },
            {
                path: 'version/index',
                component: () => import('./views/admin/version/Index.vue')
            },
            {
                path: 'version/edit',
                component: () => import('./views/admin/version/Edit.vue')
            },
            {
                path: 'data/index',
                component: () => import('./views/admin/data/Index.vue')
            },
            {
                path: 'history/index',
                component: () => import('./views/admin/history/Index.vue')
            },
            {
                path: 'task/Index',
                component: () => import('./views/admin/task/Fail.vue')
            },
            {
                path: 'task/fail',
                component: () => import('./views/admin/task/Fail.vue')
            },
            {
                path: 'plugin/cat-index',
                component: () => import('./views/admin/plugin/CatIndex.vue')
            },
            {
                path: 'plugin/cat-edit',
                component: () => import('./views/admin/plugin/CatEdit.vue')
            },
            {
                path: 'template/index',
                component: () => import('./views/admin/template/Index.vue')
            },
            {
                path: 'template/edit',
                component: () => import('./views/admin/template/Edit.vue')
            },
            {
                path: 'template-order/index',
                component: () => import('./views/admin/template-order/Index.vue')
            }
            ]
        }
        ]
    }
    ]
})
